import cn from 'classnames'
import { forwardRef, ReactNode } from 'react'

import styles from './AssetListItemLayout.module.scss'

import Arrow from '~lib/ui-kit/Arrow'
import Col from '~lib/ui-kit/Col'
import Collapse from '~lib/ui-kit/Collapse'
import Row from '~lib/ui-kit/Row'
import Space from '~lib/ui-kit/Space'
import Text from '~lib/ui-kit/Text'

interface AssetListItemLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  assetOpen: boolean
  onAssetOpen: () => void
  assetType?: ReactNode
  assets?: ReactNode
  headerMenu?: ReactNode
  name?: ReactNode
  lastUpdated?: ReactNode
  lastUpdatedUserAvatar?: ReactNode
  approversInfo?: ReactNode
  editor?: ReactNode
}

const AssetListItemLayout = forwardRef<HTMLElement, AssetListItemLayoutProps>(
  (
    {
      assetOpen,
      onAssetOpen,
      assetType,
      assets,
      headerMenu,
      approversInfo,
      editor,
      lastUpdated,
      lastUpdatedUserAvatar,
      name,
      className,
      ...props
    },
    ref
  ) => {
    return (
      <article ref={ref} className={cn(styles.root, assetOpen && styles.expanded, className)} {...props}>
        <header className={cn(styles.header, assetOpen && styles.expanded)}>
          <Row align="center" gutter="1">
            <Col alignSelf="center">{assetType}</Col>

            <Col flex={1}>{name}</Col>

            {!assetOpen && <button aria-label="Expand" className={styles.expandButton} onClick={onAssetOpen} />}

            <Col className={styles.headerMenu}>{headerMenu}</Col>
          </Row>
        </header>

        <Collapse unmount opacity opened={assetOpen}>
          <div className={styles.assets}>{assets}</div>

          <div className={styles.content}>
            <div className={styles.contentInner}>{editor}</div>
          </div>

          <footer className={styles.footer}>
            <Row gutter="1">
              <Col alignSelf="center">{lastUpdatedUserAvatar}</Col>

              <Col alignSelf="center">
                <Text variant="secondary">{lastUpdated}</Text>
              </Col>

              <Col flex={1} />

              <Col>{approversInfo}</Col>
            </Row>
          </footer>

          <Space justify="center">
            <Arrow className={styles.arrowButton} direction="top" type="button" onClick={onAssetOpen} />
          </Space>
        </Collapse>
      </article>
    )
  }
)

export default AssetListItemLayout
